module.exports = __webpack_public_path__ + "static/wrong-plug-677601526d95f67cc511a2a6d0f58d50.svg";